package nl.volleyplanner.web.controller.planner.planner_configurations

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.html.*
import kotlinx.html.js.div
import kotlinx.html.js.onChangeFunction
import nl.volleyplanner.api.planner.CreatePlannerConstraintConfigurationRequest
import nl.volleyplanner.api.planner.PlannerConstraintConfiguration
import nl.volleyplanner.nevoboservice.extensions.toSlug
import nl.volleyplanner.web.ApiDataStateFlow
import nl.volleyplanner.web.VolleyPlannerApplication
import nl.volleyplanner.web.base.HTMLComponent
import nl.volleyplanner.web.base.component.validatingForm
import nl.volleyplanner.web.base.spinner
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLSelectElement
import org.w3c.xhr.FormData

class PlannerConfigurationVersionSelectionComponent(
    val plannerConfigurationsDataFlow: ApiDataStateFlow<List<PlannerConstraintConfiguration>?, *>,
    val selectedPlannerConfigurationState: MutableStateFlow<PlannerConstraintConfiguration?>
) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        val plannerConfigurations = plannerConfigurationsDataFlow.value
        val selectedConfiguration = if (plannerConfigurations != null && selectedPlannerConfigurationState.value == null) {
            selectedPlannerConfigurationState.value = plannerConfigurations.first()
            plannerConfigurations.first()
        } else {
            selectedPlannerConfigurationState.value
        }
        return consumer.div(classes = "row border bg-secondary-subtle rounded p-2 mb-2 d-print-none") {
            if (plannerConfigurations == null) {
                spinner()
            } else {
                div(classes = "col-auto") {
                    select(classes = "form-select") {
                        plannerConfigurations.forEach { configuration ->
                            option {
                                selected = selectedConfiguration!!.identifier == configuration.identifier
                                value = configuration.identifier

                                +configuration.name
                            }
                        }

                        onChangeFunction = { event ->
                            event.preventDefault()

                            val configurationId = (event.currentTarget!! as HTMLSelectElement).value
                            selectedPlannerConfigurationState.value = plannerConfigurations.first { it.identifier == configurationId }
                        }
                    }
                }
                div(classes = "col-auto ms-auto") {
                    validatingForm(
                        customValidityFunction = { formElement ->
                            val configNameElement = formElement.querySelector("input[name='configuration-name']")!! as HTMLInputElement
                            val configurationName = configNameElement.value

                            val slug = configurationName.toSlug()
                            if (plannerConfigurations.any { it.slug == slug }) {
                                configNameElement.setCustomValidity("Deze naam is al in gebruik")
                            }
                        },
                        validSubmitFunction = { event, formElement ->
                            val formData = FormData(formElement)
                            val configurationName = formData.get("configuration-name").toString()
                            val request = CreatePlannerConstraintConfigurationRequest(
                                name = configurationName,
                                ownMatchTimeReservationConstraintConfiguration = selectedConfiguration!!.ownMatchTimeReservationConstraintConfiguration,
                                ageGroupConstraints = selectedConfiguration.ageGroupConstraints,
                                balancingConstraintConfiguration = selectedConfiguration.balancingConstraintConfiguration
                            )
                            val newConfiguration = VolleyPlannerApplication.volleyplannerApiClient
                                .organisation
                                .plannerConfiguration
                                .createPlannerConfiguration(request)

                            selectedPlannerConfigurationState.value = newConfiguration
                            plannerConfigurationsDataFlow.refresh()
                        }
                    ) {
                        classes += "row align-items-center gx-2"
                        div (classes = "col-auto") {
                            input(classes = "form-control") {
                                type = InputType.text
                                name = "configuration-name"
                                required = true

                                placeholder = "Naam nieuwe configuratie"
                            }
                        }
                        div (classes = "col-auto") {
                            button(classes = "btn btn-primary") {
                                type = ButtonType.submit
                                +"Nieuwe configuratie"
                            }
                        }
                    }
                }
            }
        }
    }

    override suspend fun getState() = plannerConfigurationsDataFlow.subscribeApiResult()
}